<template>
  <div>
    <p class="type_one_title">
      <span class="bold_size">当前认证企业：</span>
      {{ license.enterpriseName }}
    </p>
    <ul class="auth_list">
      <li :class="['auth_card', { active: activeTable === 1 }]" @click="activeTableFn(1)">
        <div class="card_title">
          <div class="span">邀请法定代表人快速认证</div>
          <p class="card_tips">2分钟极速认证</p>
        </div>
        <p>通过短信或二维码邀请法定代表人完成认证</p>
      </li>
      <li
        :class="['auth_card auth_card2', { active: activeTable === 2 }]"
        @click="activeTableFn(2)"
      >
        <div class="card_title">
          <div class="span">企业授权书认证</div>
          <p class="card_tips">1个工作日</p>
        </div>
        <p>打印授权书并盖章，线上上传完成认证</p>
      </li>
      <li
        :class="['auth_card auth_card2', { active: activeTable === 3 }]"
        @click="moreAuthTypeShowEmit"
      >
        <div class="card_title">
          <div class="span">我是法定代表人</div>
          <p class="card_tips">极速认证</p>
        </div>
        <p>直接认证 &gt;&gt;</p>
      </li>
    </ul>
    <div v-show="activeTable === 1" class="type_one">
      <span style="color: rgba(0, 0, 0, 0.7)">可通过以下两种方式邀请法定代表人快速认证，二维码/短信链接有效期7天</span>
      <div class="submit_card">
        <ul class="submit_list">
          <li
            :class="['list_once', { active: activeTableSecond === 1 }]"
            @click="activeTableSecondFn(1)"
          >
            <span class="radio"></span>
            <span>分享二维码/链接</span>
          </li>
          <li
            :class="[
              'list_once list_once2',
              { active: activeTableSecond === 2 },
            ]"
            @click="activeTableSecondFn(2)"
          >
            <span class="radio"></span>
            <span>直接发送短信</span>
          </li>
        </ul>
        <!--   二维码     -->
        <div class="qrcode_box" v-show="activeTableSecond === 1">
          <qrcode :value="qrCodeImg" :size="140" leave="H" key="evidence" />
          <div class="qrcode_btn">
            <el-button
              class="qrcode_href_copy"
              :data-clipboard-text="qrCodeImg"
              @click="copyHrefFn"
              size="small"
            >复制链接</el-button>
            <el-button type="danger" @click="getProfileFn" size="small">查询认证结果</el-button>
          </div>
        </div>
        <!--   短信     -->
        <div class="sms_box" v-show="activeTableSecond === 2">
          <!--   通知后等待       -->
          <div v-if="smsAuthVisible" class="sms_loading">
            <i class="el-icon-time" style="color: #ec1c1c; font-size: 38px; font-weight: bold"></i>
            <p style="margin: 20px 0">
              已向法定代表人 {{ license.enterpriseController }}（{{
              moblieData.phone
              }}）发送认证短信，请及时通知法定代表人完成认证！
            </p>
            <div>
              <el-button @click="smsAgainFn(0)" size="small">修改手机号</el-button>
              <el-button @click="smsAgainFn(1)" size="small">再次发送短信</el-button>
              <el-button type="danger" @click="getProfileFn" size="small">查询认证结果</el-button>
            </div>
          </div>
          <!--   短信通知       -->
          <el-form
            v-else
            :model="moblieData"
            :rules="rules"
            class="sms_form"
            ref="moblieDataRef"
            size="small"
            label-width="150px"
          >
            <el-form-item prop="phone" label="法定代表人手机号:">
              <el-input
                :maxlength="11"
                :minlength="11"
                v-model="moblieData.phone"
                placeholder="法定代表人手机号"
              />
            </el-form-item>
            <!-- <el-form-item prop="imgCode" label="图像验证码:">
              <el-input
                v-model="moblieData.imgCode"
                :maxlength="4"
                :minlength="4"
                placeholder="图形验证码"
              >
                <span
                  slot="append"
                  class="img-code"
                  @click="imgCodeFn"
                  style="display: inline-block; margin: 0 -20px"
                >
                  <img :src="'data:image/png;base64,' + imgAuthData.imgPath" />
                </span>
              </el-input>
            </el-form-item>-->
            <el-form-item style="text-align: center; padding-top: 15px">
              <aliCaptcha
                :verify="getPhoneCode"
                :mobile="moblieData.phone"
                :verifyType="BUSITYPE.FASTACCOUNT"
                :handCallback="handCallback"
              >
                <el-button size="small" type="danger">确认发送</el-button>
              </aliCaptcha>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!--  企业授权书  -->
    <div v-show="activeTable === 2" class="type_second">
      <div class="second_left">
        <word-Custom
          :isInLand="isInLand"
          :license="license"
          :grantAuth="grantAuth"
          ref="wordCustomRef"
        ></word-Custom>
      </div>
      <ul class="second_right">
        <li class="second_right_li">
          <p class="right_li_btn">1.信息填写完成，下载授权书，打印并加盖公章</p>
          <el-button
            size="small"
            type="danger"
            plain
            @click="downloadFileFn"
            :loading="loadingBtn"
          >下载授权书</el-button>
        </li>
        <li class="second_right_li">
          <p class="right_li_btn">2.将加盖公章的授权书扫描或拍照后上传</p>
          <el-upload
            ref="uploadCare"
            style="width: 200px"
            action="#"
            accept=".jpg, .png, .jpeg"
            :file-list="fileList"
            :on-remove="romeFileFn"
            :before-upload="(file) => beforeIdeCareUpload(file)"
          >
            <el-button size="small" type="danger" plain :loading="loadingBtn">上传授权书</el-button>
            <div slot="tip" class="el-upload__tip">（支持jpg、png格式）</div>
          </el-upload>
        </li>
        <li class="second_right_li">
          <p class="right_li_btn">
            3. 提交认证，
            <span v-show="isInLand">被授权人完成人脸识别，</span>等待君子签审核
          </p>
          <el-button size="small" type="danger" :loading="loadingBtn" @click="submitFn">提交认证</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Cookie from "@/assets/js/lib/cookie";
import { ApiMethods, postFileTempUpload, postImgCode } from "../../assets/js/http-serve/http-methods";
import Qrcode from "qrcode.vue";
import Clipboard from "clipboard";
import { imgAuth, mobile } from "../../assets/js/lib/valid-methods";
import ImgAuthCom from '@/components/img-auth/img-auth';
import wordCustom from './wordCustom';
import ApplyTableController from "@/assets/js/http-serve/applyTableController";
import { isInDingTalk } from '../../assets/js/utils/ding-env';
import aliCaptcha from "@/components/send-auth-validcode/aliCaptcha.vue";
import { BUSITYPE } from "../../assets/js/utils/others";
import { mapGetters } from "vuex";
import { NonChinaLand } from '@/assets/js/utils/typesTool.js'
const base64 = require("js-base64").Base64;

export default {
  name: "moreAuthType",
  components: { Qrcode, ImgAuthCom, wordCustom, aliCaptcha },
  props: {
    moreAuthTypeShow: {
      type: Boolean,
    },
    //认证企业数据
    license: {
      type: Object,
    },
    isCreate: {
      type: Boolean,
    },
    //非法人数据
    notLegaFaceParam: {
      type: Object,
    }
  },
  data () {
    return {
      BUSITYPE,
      fileList: [],
      loadingBtn: false,
      activeTable: 1,
      activeTableSecond: 1,
      qrCodeImg: '',
      imgAuthData: {
        imgToken: '',
      }, //图形验证码
      moblieData: {
        phone: '',
        imgCode: ''
      },
      rules: {
        // 验证信息
        phone: [{ validator: mobile, trigger: "blur" }],
        imgCode: [{ validator: imgAuth, trigger: "blur" }],
      },
      smsAuthVisible: false, //短信通知等待
      grantAuth: {
        enterpriseController11: '',
        IDCard11: '',
        bankLinkPhone11: '',
        bankLinkEmail: '',
      }, //被授权人信息
      // notLegaFaceParam: {}, //非法人数据
    }
  },
  mounted () {
    this.getIdenAuthUrl();
    // this.imgCodeFn();
    if ([2, 22, 23].includes(+this.$route.query.stepPage)) {
      this.secondAuthStatusFn();
    }
    if (+this.$route.query.stepPage === 22) {
      this.activeTableSecond = 2;
      this.smsAuthVisible = true;
    }
    if (+this.$route.query.stepPage === 23) {
      this.activeTable = 2;
    }
  },
  methods: {
    //  获取图形验证码
    // imgCodeFn () {
    // postImgCode().then(({ data }) => {
    //   this.imgAuthData = data;
    // });
    // },
    //直接第二步请求数据
    secondAuthStatusFn () {
      ApiMethods.IdenAuthController.queryUserStatusInfo().then(result => {
        result.data.basicUserBean && ({
          name: this.license.enterpriseName,
          legalName: this.license.enterpriseController,
          businessLicense: this.license.businessLicenseNo,
          legalMobilePhone: this.moblieData.phone,
        } = result.data.basicUserBean);
        result.data.userExtend && ({
          authorizeName: this.grantAuth.enterpriseController11,
          authorizeCard: this.grantAuth.IDCard11,
          authorizeMobilePhone: this.grantAuth.bankLinkPhone11,
        } = result.data.userExtend);
      })
    },
    async submitFn () {
      const info = await this.$refs.wordCustomRef.submit();
      if (!info) return;
      const param = {
        name: this.license.enterpriseName, // 企业名称
        businessLicense: this.license.businessLicenseNo, // 营业执照号
        legalName: this.license.enterpriseController, // 法人姓名
        legalIdentityNo: "", // 法人身份证号
        legalPhone: "", // 法人手机号
        businessLicenseImg: this.license.targetId // 营业执照扫描件
      };
      //修改非法人数据，供后续使用
      ({
        grant_targetId: this.notLegaFaceParam.file,
        enterpriseController11: this.notLegaFaceParam.authorizeName,
        bankLinkPhone11: this.notLegaFaceParam.authorizeMobilePhone,
        IDCard11: this.notLegaFaceParam.authorizeCard,
      } = this.grantAuth)
      // 如果是个人创建企业
      if (this.isCreate) {
        param.need_splice = base64.encode(JSON.parse(Cookie.get("e_token"))); // 要替换的token
        this.notLegaFaceParam.need_splice = base64.encode(
          JSON.parse(Cookie.get("e_token"))
        );
      }
      // 企业授权书认证
      this.loadingBtn = true;
      if (!this.isInLand) {
        param.file = this.grantAuth.grant_targetId
        param.authorizeName = this.grantAuth.enterpriseController11
        param.authorizeEmail = this.grantAuth.bankLinkEmail
        param.authorizeCard = this.grantAuth.IDCard11
      }
      const approveApi = this.isInLand ? 'enterpriseQzyAuth' : 'ApproveCommitNonChinese';
      ApiMethods.IdenAuthController[approveApi](param).then(res => {
        if (!res.success) {
          this.loadingBtn = false;
          return this.$message.error(res.description || this.$tip);
        }
        this.isInLand ? this.notLegafaceRefresh() : this.$emit('queryApproveStatus');
      })
        .catch(error => {
          this.loadingBtn = false;
          console.info(error);
        }).finally(() => { this.loadingBtn = false; });
    },
    notLegafaceRefresh () {
      ApiMethods.IdenAuthController.approveCommitFaceUrl(this.notLegaFaceParam)
        .then(result => {
          this.loadingBtn = false;
          if (result.success) {
            // 将结果回显成二维码给用户
            this.$emit('notLegafaceDialogEmit', result.data);
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    //下载
    async downloadFileFn () {
      const info = await this.$refs.wordCustomRef.submit();
      if (!info) return this.$message.error('请先完善授权人信息！');
      const param = {
        enterName: this.license.enterpriseName,
        enterIdNo: this.license.businessLicenseNo,
        legalName: this.license.enterpriseController,
        // legalIdNo: this.license.IDCard,
        authName: this.grantAuth.enterpriseController11,
        authMobi: this.grantAuth.bankLinkPhone11,
        authIdNo: this.grantAuth.IDCard11,
        authEmail: this.grantAuth.bankLinkEmail,
      }
      // 当是非大陆时，需要传入 applyTableVersion
      if (param.authEmail) param.applyTableVersion = 'fdl'
      await ApplyTableController.downApplyTableRq(param)
    },
    romeFileFn (file) {
      this.grantAuth.grant_targetId = '';
    },
    //  上传
    beforeIdeCareUpload (file) {
      const re = new RegExp("(.jpg|.png|.jpeg)$", "i");
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!re.test(file.name)) {
        this.$message.error("文件格式只能是jpg/png/jpeg的文件");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
      this.loadingBtn = true;
      this.fileList = [file]
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingBtn = false;
          this.grantAuth.grant_targetId = data.tempFile.targetId;
          // this.OCR(data.tempFile.targetId);
        })
        .catch(err => {
          this.loadingBtn = false;
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    OCR (targetId) {
      ApiMethods.IdenAuthController.ocrIdCard({
        file: targetId,
        front: 1
      })
        .then(res => {
          this.loadingBtn = false;
          if (res.success) {
            res.data.idNo && (this.grantAuth.IDCard11 = res.data.idNo);
            res.data.idName && (this.grantAuth.enterpriseController11 = res.data.idName);
          } else {
            if(respon.code == "10807") return this.$message.error('识别不成功（代码：23)');
            this.$message.error("识别失败，请重新拍摄图片并上传。");
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    smsAgainFn (type) {
      // this.imgCodeFn();
      // this.moblieData.imgCode = '';
      this.moblieData.phone = '';
      this.smsAuthVisible = false;
    },
    // 获取手机验证码 前置校验
    getPhoneCode (callback) {
      this.$refs['moblieDataRef'].validateField('phone', (error) => {
        if (!error) {
          // this.bankValidCode.showImageCode = true;
          if (callback) callback()
        }
      });
    },
    handCallback () {
      this.smsAuthVisible = true
    },
    //  短信发送
    enterpriseAuthSendIdenSmsFn () {
      this.$refs.moblieDataRef.validate(vaild => {
        if (vaild) {
          let param = {
            mobile: this.moblieData.phone,
            // imgCode: this.imgAuthData.imgToken + "_" + this.moblieData.imgCode
          };
          if (this.isCreate) {
            param.need_splice = base64.encode(JSON.parse(Cookie.get("e_token"))); // 要替换的token
          }
          ApiMethods.IdenAuthController.enterpriseAuthSendIdenSms(param).then(res => {
            if (res.success) {
              this.smsAuthVisible = true;
            } else {
              // this.imgCodeFn();
              this.$message.error(res.description)
            }
          })
        }
      })

    },
    //  查询结果
    getProfileFn () {
      let param = {}
      if (this.isCreate) {
        param.need_splice = base64.encode(JSON.parse(Cookie.get("e_token"))); // 要替换的token
      }
      ApiMethods.ProfileController.profile(param).then(res => {
        if (res.success) {
          if (res.data.accountInfoVO.identityAuth === 1) {
            this.$message.success('认证成功')
            if (isInDingTalk) {
              const session = sessionStorage;
              const dingloginInfo = JSON.parse(session.getItem("dingloginInfo"));
              this.$router.replace({
                path: `/login/middle?corpId=${dingloginInfo.dingTalkCorpId}`
              })
            }else{
              this.$router.replace({
                path: '/viewIndex'
              })
            }
          } else {
            this.$message.warning('认证未完成，请稍后')
          }
        } else {
          this.$message.error(res.description)
        }
      })
    },
    //  复制
    copyHrefFn (href) {
      const clipboard = new Clipboard(".qrcode_href_copy");
      clipboard.on("success", e => {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({
          type: "waning",
          message: "该浏览器不支持自动复制"
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    moreAuthTypeShowEmit () {
      this.$emit('update:moreAuthTypeShow', false)
    },
    //卡片切换1
    activeTableFn (val) {
      this.activeTable = val;
    },
    //卡片切换2
    activeTableSecondFn (val) {
      // if (val === 1) {
      //   this.getIdenAuthUrl();
      // }
      this.activeTableSecond = val;
    },
    //  获取验证码
    getIdenAuthUrl () {
      let param = {}
      if (this.isCreate) {
        param.need_splice = base64.encode(JSON.parse(Cookie.get("e_token"))); // 要替换的token
      }
      ApiMethods.IdenAuthController.idenAuthUrl(param).then(res => {
        this.qrCodeImg = res.data;
      })
    },
  },
  computed: {
    ...mapGetters(['allAuthUser']),
    isInLand () {
      const { registerScene } = this.allAuthUser.accountInfoVO
      return !([NonChinaLand].includes(registerScene))
    },
  }
}
</script>

<style lang="less" scoped>
.type_one_title {
  font-size: 16px;
  padding-bottom: 10px;
  .bold_size {
    font-weight: 600;
  }
}
.type_second {
  margin-top: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;

  .second_left {
    flex-grow: 1;
    padding: 10px;
  }

  .second_right {
    width: 500px;
    padding: 8px;
    margin-top: 50px;

    .second_right_li {
      margin-bottom: 20px;
      text-align: center;

      .right_li_btn {
        margin-bottom: 10px;
        font-weight: bold;
      }
    }
  }
}

.type_one {
  margin-top: 20px;

  .submit_card {
    border: 1px solid #d3d3d3;
    padding: 20px;
    margin-top: 10px;
    border-radius: 8px;

    .submit_list {
      display: flex;
      justify-content: center;
      margin-bottom: 15px;

      .list_once {
        /*width: 48%;*/
        /*border: 1px solid #d3d3d3;*/
        /*border-radius: 8px;*/
        padding: 10px;
        cursor: pointer;

        .radio {
          display: inline-block;
          width: 6px;
          height: 6px;
          border: 4px solid #a0a0a0;
          background-color: #ffffff;
          border-radius: 50%;
          margin-right: 4px;
        }

        .radio_title {
        }

        &.list_once2 {
          margin-left: 40px;
        }

        &.active {
          border-bottom: 4px solid #ec1c1e;

          span {
            color: #ec1c1e;
          }

          .radio {
            width: 6px;
            height: 6px;
            border: 4px solid #ec1c1e;
            background-color: #ffffff;
          }
        }
      }
    }

    .qrcode_box {
      text-align: center;
      padding: 20px;

      .qrcode_btn {
        margin-top: 30px;
      }
    }

    .sms_box {
      text-align: center;
      margin-top: 30px;

      .sms_loading {
        border: 1px solid #d3d3d3;
        border-radius: 8px;
        padding: 20px;
      }

      .sms_form {
        width: 380px;
        margin: 0 auto;

        .img-code {
          background-color: #fff;
          display: inline-block;
          margin: 0 -20px;
          width: 100px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;

          img {
            vertical-align: middle;
            display: inline-block;
            height: 30px;
            width: 100%;
          }
        }
      }
    }
  }
}

.auth_list {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 15px;
  border-bottom: 1px solid #d3d3d3;
  .auth_card {
    width: 340px;
    border: 1px solid #d3d3d3;
    border-radius: 6px;
    padding: 20px 10px 20px 15px;
    cursor: pointer;
    &.auth_card2 {
      margin-left: 15px;
    }

    .card_title {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 8px;

      .span {
        font-size: 16px;
        font-weight: 600;
      }

      .card_tips {
        // background-color: #a0a0a0;
        border: 1px solid #ec1c1c;
        color: #ec1c1c;
        padding: 2px 8px;
        border-radius: 8px;
        margin-left: 10px;
      }
    }
    &.active {
      border: 1px solid #ec1c1e;
      color: #ec1c1e;
      .card_title {
        .span {
          color: #ec1c1e;
        }

        .card_tips {
          background-color: #ec1c1e;
          color: #ffffff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/auth/moreAuthType.vue